import { useQuery } from 'react-query';
import { getJobParts } from '../api/getJobParts';
import { JobPart } from '../types/JobParts';

export const useGetJobParts = () => useQuery<JobPart[] | Error>(['job-parts'], () => getJobParts());
